document.addEventListener('DOMContentLoaded', function () {
  var gridContainer = document.querySelector('#ProductGridContainer');
  if (!gridContainer) return;

  // Observe when the Load More button comes into view
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      var btn = entry.target;

      // Click this instance once, then stop observing it
      observer.unobserve(btn);
      btn.click();
    });
  }, {
    root: null,
    rootMargin: '400px 0px 0px 0px', // start loading a bit before it hits the viewport
    threshold: 0
  });

  function watchLoadMore() {
    // Find a visible load-more button with an href
    var btn = document.querySelector('.load-more-btn[href]:not(.hidden)');
    if (!btn) return;

    observer.observe(btn);
  }

  // Initial attach
  watchLoadMore();

  // When pagination area changes (after AJAX load), re-attach to the new button
  var paginationWrapper = document.querySelector('#load-pagination')?.parentElement;
  if (paginationWrapper) {
    var mo = new MutationObserver(function () {
      watchLoadMore();
    });
    mo.observe(paginationWrapper, { childList: true, subtree: true });
  }
});
